<template>
  <CommonBanner
    class="red-close__banner"
    :tagline="
      $t`Чтобы продолжить, дайте согласие на сбор и обработку персональных данных`
    "
    type="neutral"
  />
  <BarButton
  @click="$router.push('/bank/red/agreement')"
    iconHead="i-bills"
    :title="$t`Согласие`"
  />
  <CommonButton @click="goToScoring" spaced>
    {{ $t`Даю согласие, продолжить` }}
  </CommonButton>
</template>

<script>
import CommonBanner from "@/components/shared/banner/CommonBanner";
import CommonButton from "@/components/shared/button/CommonButton";
import BarButton from "@/components/shared/button/BarButton";
import { saveConsent } from "@/api/consent";

export default {
  components: {
    CommonBanner,
    CommonButton,
    BarButton,
  },
  data() {
    return {
      isSmsModalOpen: false,
    };
  },
  async created() {},
  methods: {
    async goToScoring() {
      await saveConsent(true);
      this.$router.replace("/bank/red/limits");
    },
  },
};
</script>
